module.exports = __webpack_public_path__ + "img/UnauthLeftCard.341de07f.jpg";